import { IPHONE_SCREEN_TYPE } from '../config/constants';



export const hasWidthAndHeight = ({ width, height }) => width && height;

export const filterByIphoneScreen = (videos = [], screenshots = []) => {
  const screenshotsWithSize = screenshots.filter(hasWidthAndHeight);
  const videosWithSize = videos.filter(({ preview }) => hasWidthAndHeight(preview));
  const iphoneScreenSize = window.iphoneScreenSize;
  const imgByScreen = {
    [IPHONE_SCREEN_TYPE.SCREEN_6_5]: {
      videos: videosWithSize.filter(({ preview }) => preview.screen_type === IPHONE_SCREEN_TYPE.SCREEN_6_5),
      screenshots: screenshotsWithSize.filter(({ screen_type }) => screen_type === IPHONE_SCREEN_TYPE.SCREEN_6_5)
    },
    [IPHONE_SCREEN_TYPE.SCREEN_5_8]: {
      videos: videosWithSize.filter(({ preview }) => preview.screen_type === IPHONE_SCREEN_TYPE.SCREEN_5_8),
      screenshots: screenshotsWithSize.filter(({ screen_type }) => screen_type === IPHONE_SCREEN_TYPE.SCREEN_5_8)
    },
    [IPHONE_SCREEN_TYPE.SCREEN_5_5]: {
      videos: videosWithSize.filter(({ preview }) => (preview.screen_type === IPHONE_SCREEN_TYPE.SCREEN_5_5) || !preview.screen_type),
      screenshots: screenshotsWithSize.filter(({ screen_type }) => (screen_type === IPHONE_SCREEN_TYPE.SCREEN_5_5) || !screen_type)
    },
    [IPHONE_SCREEN_TYPE.SCREEN_4_7]: {
      videos: videosWithSize.filter(({ preview }) => preview.screen_type === IPHONE_SCREEN_TYPE.SCREEN_4_7),
      screenshots: screenshotsWithSize.filter(({ screen_type }) => screen_type === IPHONE_SCREEN_TYPE.SCREEN_4_7)
    }
  };

  for (const [ key, value ] of Object.entries(imgByScreen)) {
    imgByScreen[key].videos = value.videos.length ? value.videos : null;
    imgByScreen[key].screenshots = value.screenshots.length ? value.screenshots : null;
  }

  let screenshotSet = null;
  let videoSet = null;

  switch (iphoneScreenSize) {
    case IPHONE_SCREEN_TYPE.SCREEN_6_5:
    case IPHONE_SCREEN_TYPE.SCREEN_5_8:
      screenshotSet = imgByScreen[IPHONE_SCREEN_TYPE.SCREEN_6_5].screenshots || imgByScreen[IPHONE_SCREEN_TYPE.SCREEN_5_8].screenshots;
      videoSet = imgByScreen[IPHONE_SCREEN_TYPE.SCREEN_6_5].videos || imgByScreen[IPHONE_SCREEN_TYPE.SCREEN_5_8].videos;
      break;
    case IPHONE_SCREEN_TYPE.SCREEN_5_5:
    case IPHONE_SCREEN_TYPE.SCREEN_4_7:
    case IPHONE_SCREEN_TYPE.SCREEN_4_0:
      screenshotSet = imgByScreen[IPHONE_SCREEN_TYPE.SCREEN_5_5].screenshots || imgByScreen[IPHONE_SCREEN_TYPE.SCREEN_4_7].screenshots;
      videoSet = imgByScreen[IPHONE_SCREEN_TYPE.SCREEN_5_5].videos || imgByScreen[IPHONE_SCREEN_TYPE.SCREEN_4_7].videos;
      break;
    default:
      screenshotSet = imgByScreen[IPHONE_SCREEN_TYPE.SCREEN_5_5].screenshots;
      videoSet = imgByScreen[IPHONE_SCREEN_TYPE.SCREEN_5_5].videos;
  }

  if (!screenshotSet && !videoSet) {
    screenshotSet = imgByScreen[IPHONE_SCREEN_TYPE.SCREEN_5_5].screenshots || imgByScreen[IPHONE_SCREEN_TYPE.SCREEN_4_7].screenshots;
    videoSet = imgByScreen[IPHONE_SCREEN_TYPE.SCREEN_5_5].videos || imgByScreen[IPHONE_SCREEN_TYPE.SCREEN_4_7].videos;
  }

  return {
    videos: videoSet || [],
    screenshots: screenshotSet || []
  };
};



// WEBPACK FOOTER //
// ./src/lib/ios-gallery-service.js